import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function CostBreakdownToggle({
  monthlyRent,
  emi,
  yearlyMortgage,
  downPayment,
  totalMortgage,
  stayYears,
}) {
  const [active, setActive] = useState("rent");

  // same logic as your reference
  const totalRentCost =
    (monthlyRent * 12 + 5195) * stayYears;

  return (
    <Container className="my-5">
      <Row>
        <Col>
          <div className="breakdown-card">
            {/* ================= TOGGLE BUTTONS ================= */}
            <Row className="mb-4  ">
              <Col md={6} sm={6} className="mb-2">
                <button
                  className={`toggle-btn ${
                    active === "rent" ? "active" : ""
                  }`}
                  onClick={() => setActive("rent")}
                >
                  Rent Cost Breakdown
                </button>
              </Col>
              <Col md={6} sm={6} >
                <button
                  className={`toggle-btn ${
                    active === "buy" ? "active" : ""
                  }`}
                  onClick={() => setActive("buy")}
                >
                  Buy Cost Breakdown
                </button>
              </Col>
            </Row>

            {/* ================= RENT SUMMARY ================= */}
            {active === "rent" && (
              <>
                <SummaryRow
                  label="Monthly Rent"
                  value={`Rs ${monthlyRent.toFixed(2)}`}
                />
                <SummaryRow
                  label="Agent Commission"
                  value="Rs 5000"
                />
                <SummaryRow
                  label="Extra fee"
                  value="Rs 195"
                />

                <p className="vat-text">
                  + VAT where applicable
                </p>

                <TotalStrip
                  label={`TOTAL RENTING COST OVER ${stayYears} YEARS:`}
                  value={`Rs ${totalRentCost.toFixed(2)}`}
                />

                <p className="note-text">
                  *Based on a yearly agent commission fee
                </p>
              </>
            )}

            {/* ================= BUY SUMMARY ================= */}
            {active === "buy" && (
              <>
                <SummaryRow
                  label="Down Payment"
                  value={`Rs ${downPayment}`}
                />
                <SummaryRow
                  label="Yearly Mortgage Payment"
                  value={`Rs ${yearlyMortgage.toFixed(2)}`}
                />
                <SummaryRow
                  label="Monthly Mortgage Payment"
                  value={`Rs ${emi.toFixed(2)}`}
                />

                <p className="vat-text">
                  + VAT where applicable
                </p>

                <TotalStrip
                  label="TOTAL BUYING COST OVER YEARS:"
                  value={`Rs ${totalMortgage.toFixed(2)}`}
                />
              </>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

/* ================= REUSABLE ROW ================= */

function SummaryRow({ label, value }) {
  return (
    <Row className="mb-3">
      <Col>{label}</Col>
      <Col className="text-end fw-semibold">
        {value}
      </Col>
    </Row>
  );
}

/* ================= TOTAL STRIP ================= */

function TotalStrip({ label, value }) {
  return (
    <div className="total-strip">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}
